class ProductCard {
    constructor() {
        this.events();
        this.isProductInitialized = false;
    }

    events() {
        // Initialize product card
        if (!this.isProductInitialized) {
            this.initializeProductCard();
        }

        document.addEventListener('facetwp-loaded', () => {
            // console.log('FacetWP loaded');
            if (!this.isProductInitialized) {
                this.initializeProductCard();
            }
        });

        document.addEventListener('facetwp-refresh', () => {
            // console.log('FacetWP refreshed');
            this.isProductInitialized = false; // Reset initialization flag
        });

        $(document.body).on('added_to_cart', (res, fragments) => {
            this.removeAddedClassFromButtons();
        });
    }

    removeAddedClassFromButtons() {
        // Get all product cards
        const productCards = document.querySelectorAll('.product');

        // Loop through each product card
        productCards.forEach(productCard => {
            const variationButtons = productCard.querySelectorAll('.ajax_add_to_cart');

            // Loop through each variation button
            variationButtons.forEach(variationButton => {
                setTimeout(() => {
                    // Remove the 'added' class from variation buttons
                    variationButton.classList.remove('added');
                }, 2000);
            });

            // Remove added to cart link
            setTimeout(() => {
                const viewCartLink = document.querySelector('.added_to_cart');
                if(viewCartLink) {
                    viewCartLink.remove();
                }
                const added = document.querySelector('.added');
                if(added) {
                    added.classList.remove('added');
                }
            }, 6000);
        });
    }

    initializeProductCard() {
        this.isProductInitialized = true;

        // Get all product cards
        const productCards = document.querySelectorAll('.product');
        const singleProductPage = document.body.classList.contains('single-product');

        // Loop through each product card
        productCards.forEach(productCard => {
            if(productCard.classList.contains('product-type-variable') && !singleProductPage) {
                // Get the product card's variation buttons
                const variationButtons = productCard.querySelectorAll('.variation-button');

                // Loop through each variation button
                variationButtons.forEach(variationButton => {
                    // Add click event listener
                    variationButton.addEventListener('click', (e) => {
                        e.preventDefault();

                        // Get the product card's variation buttons
                        const variationButtons = productCard.querySelectorAll('.variation-button');

                        // Loop through each variation button
                        variationButtons.forEach(button => {
                            // Set the data-active attribute to false
                            button.dataset.active = 'false';
                        });

                        // Set the data-active attribute to true
                        e.target.dataset.active = 'true';

                        // Check if the variation button has a data-image attribute
                        if (e.target.dataset.image) {
                            // Update the product image only if data-image attribute exists
                            const productThumbnail = e.target.closest('.product-type-variable').querySelector('.product-thumbnail .product-thumb');
                            productThumbnail.removeAttribute('srcset');
                            productThumbnail.src = e.target.dataset.image;
                        }

                        // Update product price
                        const variationPrice = productCard.querySelector('.price-html del > span > bdi');
                        const variationSalePrice = productCard.querySelector('.price-html ins > span > bdi');

                        const regularPrice = e.target.dataset.price || '';
                        const [regularEuro, regularCent] = regularPrice.split('.');
                        const salePrice = e.target.dataset.salePrice || '';
                        const [saleEuro, saleCent] = salePrice.split('.');

                        if (variationPrice) {
                            variationPrice.textContent = regularPrice ? `${regularPrice}` : '';
                        }

                        if (variationSalePrice) {
                            variationSalePrice.textContent = salePrice ? `${salePrice}` : '';
                        }

                        // Update price container HTML
                        const priceContainer = productCard.querySelector('.price-html');

                        if (salePrice) {
                            priceContainer.innerHTML = `
                                <span class="price">
                                    <del><span class="woocommerce-Price-amount amount"><bdi>${(regularEuro) ? regularEuro : ''}.<sup class="small-decimal">${(regularCent) ? regularCent : ''}</sup></bdi></span></del> 
                                    <ins><span class="woocommerce-Price-amount amount"><bdi>${(saleEuro) ? saleEuro : ''}.<sup class="small-decimal">${(saleCent) ? saleCent : ''}</sup></bdi></span></ins>
                                </span>`;
                        } else {
                            priceContainer.innerHTML = `
                                <span class="price">
                                    <del><span class="woocommerce-Price-amount amount"><bdi></bdi></span></del> 
                                    <ins><span class="woocommerce-Price-amount amount"><bdi>${(regularEuro) ? regularEuro : ''}.<sup class="small-decimal">${(regularCent) ? regularCent : ''}</sup></bdi></span></ins>
                                </span>`;
                        }

                        if ((e.target.dataset.id && e.target.dataset.id !== 'undefined')) {
                            if(e.target.dataset.stock === 'instock') {
                                // Update product button
                                let closestProduct = e.target.closest('.product');
                                let addToCartButton = closestProduct.querySelector('.ajax_add_to_cart');
                                let btnWrapper = closestProduct.querySelector('.btn-wrapper');
                                let variationId = e.target.dataset.id;
                                let variationSKU = e.target.dataset.sku;

                                let btnHTML = `<button data-quantity="1" class="button add_to_cart_button ajax_add_to_cart" data-product_id="${variationId}" data-product_sku="${variationSKU}" aria-label="Add to cart: Droge Huid Zalf" rel="nofollow"><span class="add-now" data-add="Voeg toe" data-added="Toegevoegd"></span></button>`;

                                btnWrapper.innerHTML = btnHTML;

                            } else {
                                let closestProduct = e.target.closest('.product');
                                let btnWrapper = closestProduct.querySelector('.btn-wrapper');
                                let variationId = e.target.dataset.id;
                                let variationUrl = e.target.dataset.url;

                                let btnHTML = `<a href="${variationUrl}" class="button waitlist-btn" data-product_id="${variationId}">Wachtlijst</a>`;

                                btnWrapper.innerHTML = btnHTML;
                            }
                        }
                    });
                });
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new ProductCard();
});
